import { Controller } from '@hotwired/stimulus'
import { DataTable } from 'simple-datatables'

export default class extends Controller {
  static targets = ['table']
  static values = {
    searchable: Boolean,
    sortable: Boolean,
    fixedHeight: Boolean,
    paging: Boolean,
    perPage: Number,
    perPageSelect: Array,
    filterActive: Boolean,
  }

  connect() {
    this._dtOptions = {
      searchable: this.hasSearchableValue ? this.searchableValue : true,
      sortable: this.hasSortableValue ? this.sortableValue : true,
      fixedHeight: this.hasFixedHeightValue ? this.fixedHeightValue : false,
      paging: this.hasPagingValue ? this.pagingValue : true,
      perPage: this.hasPerPageValue ? this.perPageValue : 100,
      perPageSelect: this.hasPerPageSelectValue
        ? this.perPageSelectValue
        : [[100], [50], [20], [10]],
    }
    this.dataTable = new DataTable(this.tableTarget, this._dtOptions)

    this.dataTable.on('datatable.search', (query, matched) => {
      this.dispatch('search', { detail: { matched } })
    })
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable.destroy()
    }
  }

  refresh() {
    if (this.dataTable) {
      this.dataTable.refresh()
    }
  }

  refreshAfterStream(event) {
    if (this.filterActiveValue) {
      event.preventDefault()
      return
    }

    requestAnimationFrame(() => requestAnimationFrame(() => this._rebuild()))
  }

  _rebuild() {
    if (!this.dataTable) return
    const base = document.createElement('div')
    base.innerHTML = this.dataTable._initialHTML
    const baseTable = base.querySelector('table')

    const currentTbody = this.dataTable.dom.querySelector('tbody')
    const baseTbody = baseTable.querySelector('tbody')
    if (currentTbody && baseTbody) {
      baseTbody.replaceWith(currentTbody.cloneNode(true))
    }

    this.dataTable._initialHTML = baseTable.outerHTML
    this.dataTable.destroy()
    this.dataTable = new DataTable(this.tableTarget, this._dtOptions)
  }
}
